import React from 'react';
import { Icon } from './Icon.js';
export const IconProfileBasicFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M1.5 4.5C1.5 2.01472 3.51472 -6.10673e-07 6 -3.93402e-07C8.48528 -1.76132e-07 10.5 2.01472 10.5 4.5C10.5 6.98528 8.48528 9 6 9C3.51472 9 1.5 6.98528 1.5 4.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.75 10C10.1642 10 10.5 10.3358 10.5 10.75C10.5 11.1642 10.1642 11.5 9.75 11.5H2.25C1.83579 11.5 1.5 11.1642 1.5 10.75C1.5 10.3358 1.83579 10 2.25 10H9.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconProfileBasicFill12.js.map